import styled from 'styled-components';
import { mediaMax } from '../Media Template/Media Template';

export const Header = styled.header.attrs({})`
  height: 56px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
  z-index: 90;
  box-shadow: 0 3px 3px 0 rgba(193, 193, 193, 0.5);
`;

export const LogoNavSearchContainer = styled.div.attrs({})`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
`;

export const LogoHolder = styled.div.attrs({})`
  height: 100%;
  display: flex;
  align-items: center;
`;

export const Nav = styled.nav.attrs({})`
  height: 100%;
  display: flex;
  align-items: center;
  ${mediaMax.desktop`display: none;`};
`;
